export default {};
export const API_URL = "https://checkout.rch.lol/v2.18/";
export const CURRENCY_URL = "https://fe-support.rch.lol/";
export const STASH_URL = "https://stash.rch.lol/";
export const SIGN_URL = "https://fe-support.rch.lol/";
export const CLIENTS_URL = "/clients/";
